import Head from "next/head";
import Image from "next/image";
import { useTranslation } from "next-i18next";
import { css } from "@filadd/phi-plus-styled-system/css";
import { Button } from "@filadd/phi-plus-core";

interface Props {
  title?: string;
  description?: string;
  button?: string;
}

export const ErrorPage = ({
  title = "errorPage.title",
  description = "errorPage.description",
  button = "errorPage.button",
}: Props) => {
  const { t } = useTranslation("common");

  return (
    <div
      className={css({
        height: "100vh",
        display: "flex",
        flexDir: "column",
        alignItems: "center",
        textAlign: "center",
        justifyContent: "center",
        gap: 4,
      })}
    >
      {Boolean(t("common:noAccessImage")) && (
        <Image
          alt={t("common:appName")}
          src={t("common:noAccessImage") || ""}
          width={313}
          height={200}
        />
      )}
      <Head>
        <title>{t(title)}</title>
      </Head>
      <h2
        className={css({
          color: "primary",
          fontSize: "3xl",
          fontWeight: "bold",
          textAlign: "center",
        })}
      >
        {t(title)}
      </h2>

      {t(description)}

      <Button asChild>
        <a href="/">{t(button)}</a>
      </Button>
    </div>
  );
};
